import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/*
 * @Author: Phoenix
 * @Date: 2020-03-26 16:00:39
 * @LastEditTime: 2020-04-21 13:32:03
 * @Description: routes of customers
 * @FilePath: /ups-single-window-web/src/router/modules/customers.js
 * @未经本人许可，任何单位及个人不得以任何方式对本产品进行使用、复制、修改、抄录、传播或与其它产品捆绑使用、销售。
 */
import Layout from '@/layout';
import roles from '../roles';
export default [{
  path: '/customer-welcome',
  component: Layout,
  // hidden: true,
  children: [{
    path: '',
    hidden: true,
    component: function component() {
      return import('@/views/welcome');
    }
  }]
}, {
  path: '/customs-clearance-supply',
  component: Layout,
  meta: {
    title: '报关单证',
    icon: 'clearance-choose-dark',
    roles: [roles.roleCustomer],
    level: 1
  },
  children: [{
    path: '',
    redirect: 'export',
    hidden: true
  }, {
    path: 'export',
    component: function component() {
      return import('@/views/customers/customs-clearance');
    },
    name: 'customs-clearance-supply-export',
    meta: {
      title: '出口报关',
      level: 2
    },
    children: [{
      path: 'export-b',
      name: 'customs-clearance-supply-export-b',
      meta: {
        title: '个人物品申报(B类)',
        level: 3
      },
      component: function component() {
        return import('@/views/customers/customs-clearance-b/list');
      }
    }, {
      path: 'export-c',
      name: 'customs-clearance-supply-export-c',
      meta: {
        title: '低值货物快件(C类)',
        level: 3
      },
      component: function component() {
        return import('@/views/customers/customs-clearance-c/list');
      }
    }, {
      path: 'export-d',
      name: 'customs-clearance-supply-export-d',
      meta: {
        title: '正式申报类货物(D类)',
        level: 3
      },
      component: function component() {
        return import('@/views/customers/customs-clearance/list');
      }
    }]
  }, {
    path: 'import',
    component: function component() {
      return import('@/views/customers/customs-clearance');
    },
    name: 'customs-clearance-supply-import',
    // hidden: process.env.VUE_APP_ENV === 'production',
    meta: {
      title: '进口报关',
      level: 2
    },
    children: [{
      path: 'import-b',
      name: 'customs-clearance-supply-import-b',
      meta: {
        title: '个人物品申报(B类)',
        level: 3
      },
      component: function component() {
        return import('@/views/customers/customs-clearance-b/list');
      }
    }, {
      path: 'import-c',
      name: 'customs-clearance-supply-import-c',
      meta: {
        title: '低值货物快件(C类)',
        level: 3
      },
      component: function component() {
        return import('@/views/customers/customs-clearance-c/list');
      }
    }, {
      path: 'import-d',
      name: 'customs-clearance-supply-import-d',
      meta: {
        title: '正式申报类货物(D类)',
        level: 3
      },
      component: function component() {
        return import('@/views/customers/customs-clearance/list');
      }
    }]
  }, {
    path: 'detail/:shipmentType',
    hidden: true,
    component: function component() {
      return import('@/views/customers/customs-clearance/detail');
    },
    name: 'customs-clearance-supply-detail',
    meta: {
      title: '报关申报',
      activeMenu: ''
    }
  }, {
    path: 'detail-c/:shipmentType',
    hidden: true,
    component: function component() {
      return import('@/views/customers/customs-clearance-c/detail');
    },
    name: 'customs-clearance-supply-detail-c',
    meta: {
      title: '报关申报',
      activeMenu: ''
    }
  }, {
    path: 'detail-b/:shipmentType',
    hidden: true,
    component: function component() {
      return import('@/views/customers/customs-clearance-b/detail');
    },
    name: 'customs-clearance-supply-detail-b',
    meta: {
      title: '报关申报',
      activeMenu: ''
    }
  }]
}, {
  path: '/customers-status-query',
  component: Layout,
  meta: {
    title: '海关申报状态查询',
    icon: 'status_query',
    select_icon: 'status_query_select',
    roles: [roles.roleCustomer]
  },
  children: [{
    path: '',
    hidden: true,
    component: function component() {
      return import('@/views/customers/customers-status-query/index');
    }
  }]
}, {
  path: '/customers-center',
  component: Layout,
  meta: {
    title: '个人中心',
    icon: 'VIPcenterfalse-dark',
    roles: [roles.roleCustomer],
    level: 1
  },
  children: [{
    path: '',
    redirect: 'account'
  }, {
    path: 'account',
    component: function component() {
      return import('@/views/customers/customers-center/account');
    },
    name: 'customers-center-account',
    meta: {
      title: '登录账号信息',
      level: 2
    }
  }, {
    path: 'trade',
    component: function component() {
      return import('@/views/customers/customers-center/trade');
    },
    name: 'customers-center-trade',
    meta: {
      title: '贸易公司信息',
      level: 2
    }
  }, {
    path: 'product',
    component: function component() {
      return import('@/views/customers/customers-center/product');
    },
    name: 'customers-center-product',
    meta: {
      title: '商品信息',
      level: 2
    }
  }, {
    path: 'mapping',
    component: function component() {
      return import('@/views/customers/customers-center/mapping');
    },
    name: 'customers-center-mapping',
    meta: {
      title: '映射方案',
      level: 2
    }
  }, {
    path: 'bind',
    hidden: true,
    component: function component() {
      return import('@/views/customers/customers-center/bind');
    },
    name: 'customers-center-bind',
    meta: {
      title: '绑定Easy-clear ID'
    }
  }]
}];